import { render, staticRenderFns } from "./nosology-select.vue?vue&type=template&id=2cb5fe2a"
import script from "./nosology-select.vue?vue&type=script&lang=js"
export * from "./nosology-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports